import React from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import App from "components/App";

import reportWebVitals from "utils/reportWebVitals";
import { AnalyticsProvider } from "providers/analyticsProvider";
import {
    ThemeProvider,
    createTheme,
    StyledEngineProvider,
} from "@mui/material/styles";

const theme = createTheme();

// Example: token/user from Cognito (or your auth lib)
async function getAuthToken() {
    // e.g., from Amplify Auth.currentSession(), or your own SDK
    return undefined; // return a JWT if you have it
}

function getUserId() {
    // return logged-in user id if available
    const userId = localStorage.getItem("userID");
    return userId || "";
}

function getUserEmail() {
    // return logged-in user id if available*
    const userId = localStorage.getItem("userName");
    return userId || "";
}

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);
root.render(
    <AnalyticsProvider
        config={{
            endpoint: `https://uzl633jbq0.execute-api.us-east-1.amazonaws.com/prod/AnalyticsResource`,
            batchSize: 10,
            flushIntervalMs: 300000,
            getAuthToken,
            getUserId,
            getUserEmail,
        }}
    >
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </StyledEngineProvider>
    </AnalyticsProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(null);
